import React from "react";
import Image from "gatsby-image";
import { KlimalabImage } from "./KlimalabImage";

export const KlimalabData = () => {
  const images = KlimalabImage();
  return {
    color: "#1371FB",
    title: "Klimalab",
    seo:
      "Opracowaliśmy identyfikację wizualną marki Klimalab oraz zaprojektowaliśmy statyczną stronę internetową.",
    slug: "klimalab",
    hero: {
      title: "Świeże spojrzenie na WWW.",
      color: "#1371FB",
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.hero.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.detail.childImageSharp.fluid}
        />
      ),
    },
    list: {
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_bg.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_detail.childImageSharp.fluid}
        />
      ),
    },
    what_we_did: {
      title: "Kompleksowe i funkcjonalne rozwiązania",

      technologies: [
        "Strona WWW",
        "UX Workshops",
        "Identyfikacja wizualna",
        "Fotografia produktowa",
      ],
      text:
        "Opracowaliśmy identyfikację wizualną marki Klimalab oraz zaprojektowaliśmy statyczną stronę internetową. Dzięki użyciu innowacyjnych technik witryna jest intuicyjna, szybka i wydajna.  Strona internetowa marki Klimalab jest przykładem strony firmowej, której celem jest przedstawienie oferty i działalności oraz komunikacja z klientem przez formularz kontaktowy. Natomiast stworzony przez nas branding jest nowoczesny i idealnie wpasowuje się w charakter branży.",
      list: [
        "Opracowaliśmy branding marki",
        "Zaprojektowaliśmy i zakodowaliśmy stronę internetową",
        "Prowadziliśmy kampanie w Google Ads",
      ],
    },
    headers: {
      first: "Wartościowy przekaz w atrakcyjnej formie",
      second: "Intuicyjna nawigacja i szybkie ładowanie strony",
    },
    content_images: {
      first: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.kli_1.childImageSharp.fluid}
        />
      ),
      second: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.kli_2.childImageSharp.fluid}
        />
      ),
      third: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.kli_3.childImageSharp.fluid}
        />
      ),
    },
    full_images: {
      first: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.kli_1f.childImageSharp.fluid}
          />
        ),
      },
      second: {
        title: "Minimalizm i nowoczesność",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.kli_2f.childImageSharp.fluid}
          />
        ),
      },
      third: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.kli_3f.childImageSharp.fluid}
          />
        ),
      },
    },
    text_boxes: {
      first: {
        title: "Spójna identyfikacja wizualna ",
        text:
          "Współpracę z firmą Klimalab rozpoczęliśmy od opracowania brandingu: nazwy, identyfikacji wizualnej, logo i innych elementów. Nasz projekt jest nowoczesny, praktyczny i dopasowany do profilu działalności marki - montaż i serwis klimatyzacji. Występujące na stronie internetowej komponenty są ze sobą spójne i stanowią jednolity przekaz. ",
      },
    },
    sticky: {
      first: {
        main: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.kli_1s.childImageSharp.fluid}
          />
        ),
        title: "Innowacyjne rozwiązania",
        text:
          "W naszej pracy wykorzystujemy frameworki React.js i Gatsby.js, które pozwalają szybko zbudować wysoce wydajną i dynamiczną stronę internetową. To z kolei ułatwia dalsze działania na stronie związane z SEO i indeksowaniem w wyszukiwarce.",
      },
      second: {
        main: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.kli_2s.childImageSharp.fluid}
          />
        ),
        title: "W pełni responsywna strona",
        text:
          "Strona internetowa jest zaprojektowana zgodnie z techniką Responsive Web Design. Dzięki temu przeglądanie jej zawartości jest możliwe zarówno na urządzeniach stacjonarnych, jak i mobilnych, a prezentowane treści wyglądają tak samo dobrze. ",
      },
    },
  };
};
